(() => {
  const onClick = (event) => {
    const button = event.target.closest('[data-copy-address]');
    if (!button) return;

    const address = button.dataset.copyAddress || '';
    if (!address) return;

    const label = button.querySelector('.contact-chroxel__copy-btn-label');
    const original = label ? label.textContent : '';
    const copiedLabel = button.dataset.copiedLabel || '¡Copiado!';

    const showFeedback = () => {
      button.classList.add('is-copied');
      if (label) label.textContent = copiedLabel;
      window.clearTimeout(button._copyTimer);
      button._copyTimer = window.setTimeout(() => {
        button.classList.remove('is-copied');
        if (label) label.textContent = original;
      }, 2000);
    };

    const fallbackCopy = () => {
      const textarea = document.createElement('textarea');
      textarea.value = address;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        showFeedback();
      } catch (e) {
        /* no-op */
      }
      document.body.removeChild(textarea);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(address).then(showFeedback).catch(fallbackCopy);
    } else {
      fallbackCopy();
    }
  };

  document.addEventListener('click', onClick);
})();
